import { Box, Card } from "@mui/material";
import SearchInput from "components/SearchInput";
import FaiBox from "MuiComponents/FaiBox";
import DataList from "screens/Catalog/Inventory/component/DataList";
// import DataList from "screens/Catalog/Inventory/component/DataList";
import PageHeader from "screens/OnBoarding/components/PageHeader";
import dataTableData from "../data/dataTableData";

export default function CategoryList({ masterCategories, setCategory, toggleStatus }) {
	return (
		<Card className="my-6 p-3 md:p-6">
			<Box>
				<Box sx={{ display: "flex", flexDirection: "column" }}>
					<PageHeader title="Categories" />
				</Box>
				<Box className="flex flex-col md:flex-row justify-between items-center w-full gap-3">
					<SearchInput placeholder="Search By Categories" />
				</Box>
				<FaiBox className={"inventory"}>
					<FaiBox className={"inventory-content"}>
						<FaiBox className={"inventory-content-body"} mt={3}>
							<DataList
								data={dataTableData(masterCategories, (row) => setCategory(row), (row) => toggleStatus(row))}
							/>
						</FaiBox>
					</FaiBox>
				</FaiBox>
			</Box>
		</Card>
	);
}
